<template>
	<div class="register_msg_yz">
		<h4 class="color_5babf4 login_title">注册新账号</h4>
		<p class="tip_sub_text">
			<span>短信验证码已发送至：</span>
			<span id="cshMobile">{{ csmobile }}</span>
		</p>
		<div class="forget_yzm login_mbtm6">
			<label class="label_focus" for="register_yzm">验证码</label>
			<input type="hidden" v-model="user.setMess"/>
			<input type="text" class="form-control inline-block input_focus login_form" @keyup.enter="reg()" id="register_yzm" v-model.trim="user.memo"/>
			<a href="javascript:void(0);" class="btn btn_send text-center" id="notify" @click="notify()">重新发送</a>
			<span id="col" style="display: none;color: #ccc;" class="label_focus">
				<label id="sendTimes" >倒计时60</label>
		    </span>
		</div>
		<p class="tip_box kfzryz-hide">
			<small class="tip_yz yzcontent">验证码错误！</small>
		</p>
		<p class="login_btn_box" id="yz_reg">
			<a href="javascript:void(0);" class="btn btn_h btn_issue margin_r_7" @click="reg()" id="cloudRegisterNg">注册</a>
			<small class="tip_sub_text" @click=" show = !show ">没有收到验证码?</small>
			|
			<router-link to="/login" id="register_btn" class="color_308de2"><small>返回登录</small></router-link>
		</p>

		<div class="text-center login_title color_c">
			<div class="" v-if="show">
				<p>
					<small>当您无法收到校验码短信市，请逐一排查以下原因：</small>
				</p>
				<p>
					<small>*手机话费余额不足或其他手机原因；</small>
				</p>
				<p>
					<small>*短信收件箱已满；</small>
				</p>
				<p>
					<small>*被手机安全软件误判而拦截；</small>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'register_msg_yz',
		data() {
			return {
				show: false,
				csmobile:this.$route.params.mobile,
				user:{
					setMess:this.$route.params.memo,
	                memo:""
	            }
	            
			}
		},
		mounted: function() {
			this.$nextTick(function() {
				this.$inputFocus(".input_focus");
				this.cshdjs();
			})
		},
		methods: {
			cshdjs() {
				var Num ="";
				$("#notify").css("display","none");
  					//倒计时
  					$("#col").css("display","inline-block");
  					var second = 60; // 剩余秒数
  				   //然后写一个定时器
  				  var mestimer=window.setInterval(function(){
  	 				second--;
  	 				$("#sendTimes").html("倒计时"+" "+second);
  	 				if(second==-1){
 					$("#sendTimes").html("倒计时关闭");
 					clearInterval(mestimer);
 					$("#col").css("display","none");
 					$("#notify").css("display","inline-block");
 					$("#notify").attr("onclick","notify()");
 					Num="";
  					}
      			}, 1000);
			},
        	notify() {
        		var Num ="";
        		var user = this.$route.params;
        		if (typeof(user.mobile) == "undefined") {
        			return;
        		}if (typeof(user.password) == "undefined") {
        			return;
        		}if (typeof(user.memo) == "undefined") {
        			return;
        		}
        		var formData = JSON.stringify(user);
        		this.$http.post('/zklccloud/register/reSendMes',formData, { emulateJSON: true }).then(function(m) {
								if(m.body.resultCode==0){
								this.user.setMess=m.body.content.memo;
		      					$("#notify").css("display","none");
		      					//倒计时
		      					$("#col").css("display","inline-block");
		      					var second = 60; // 剩余秒数
		      				   //然后写一个定时器
		      				  var mestimer=window.setInterval(function(){
		      	 				second--;
		      	 				$("#sendTimes").html("倒计时"+" "+second);
		      	 				if(second==-1){
		      	 					$("#sendTimes").html("倒计时关闭");
		      	 					clearInterval(mestimer);
		      	 					$("#col").css("display","none");
		      	 					$("#notify").css("display","inline-block");
		      	 					$("#notify").attr("onclick","notify()");
		      	 					Num="";
		      					}
      						}, 1000);
								}else if(m.body.content.switch==1){
									$(".kfzryz-hide").removeClass("kfzryz-hide");
									$(".yzcontent").text('当天最多发送5次验证码,已超过限制！');
									return;
								}else if(m.body.content.switch==2){
									$(".kfzryz-hide").removeClass("kfzryz-hide");
									$(".yzcontent").text('发送验证码失败,请联系管理员!');
									return;
								}
        		})
        	},
        	reg() {
        		if(this.user.memo==""){
        			$(".kfzryz-hide").removeClass("kfzryz-hide");
					$(".yzcontent").text('请输入验证码');
        			return;
        		}else if(this.user.memo!=this.user.setMess){
        			$(".kfzryz-hide").removeClass("kfzryz-hide");
					$(".yzcontent").text('验证码输入错误,请重新输入');
        			return;
        		}
        		var time1 = new Date();
        		time1.setHours(0); //获取当前小时数(0-23)
				time1.setMinutes(0); //获取当前分钟数(0-59)
				time1.setSeconds(0); //获取当前秒数(0-59)
				time1.setMilliseconds(0); //获取当前毫秒数(0-999)
        		var startTime = time1;
        		var time2 = new Date();
        		time2.setHours(23); //获取当前小时数(0-23)
				time2.setMinutes(59); //获取当前分钟数(0-59)
				time2.setSeconds(59); //获取当前秒数(0-59)
				time2.setMilliseconds(999); //获取当前毫秒数(0-999)
				var endTime = time2;
        		var user = this.$route.params;
				user.startTime=startTime.valueOf();
				user.endTime=endTime.valueOf();
				user.yzmlx='1';
        		var formData = JSON.stringify(user);
        		this.$http.post('/zklccloud/register/checkCodeInvalid',formData, { emulateJSON: true }).then(function(m) {
					//获取当前时间戳
					var timestamp = (new Date()).valueOf();
					if(timestamp>m.body.content.endTime){
						$(".kfzryz-hide").removeClass("kfzryz-hide");
						$(".yzcontent").text('验证码已失效,请重新发送验证码！');
					}else{
						var formData = JSON.stringify(user);
	    			this.$http.post('/zklccloud/register/saveuser',formData, { emulateJSON: true }).then(function(m) {
	    				
							var mobile = m.body.content.mobile ;
							var password = m.body.content.password ;
							var memo = m.body.content.memo ;
							this.$router.push({name:'register_success',
						  		params:{mobile:mobile,password:password}
							});
	    				})
					}
				});
        	}
		}
	}
</script>

<style>
.kfzryz-hide{
	display: none;
}
.register_msg_yz {
	width: 340px;
	margin: auto;
	padding: 10px;
	min-height: 500px;
}
</style>


// WEBPACK FOOTER //
// register_yz.vue?6fe2bf64